export default "__VITE_PUBLIC_ASSET__a04c6466__"